var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconAngleRightSmallSecondary(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 5,
    height: 10,
    viewBox: "0 0 5 10",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_163184",
    "data-name": "Group 163184",
    transform: "translate(9068 8056)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_81588",
    "data-name": "Path 81588",
    d: "M5,4.916a.758.758,0,0,0-.181-.424L1.068.208a.572.572,0,0,0-.886,0,.79.79,0,0,0,0,1.012L3.488,5,.185,8.777a.79.79,0,0,0,0,1.012.573.573,0,0,0,.886,0L4.815,5.508A.777.777,0,0,0,5,4.916Z",
    transform: "translate(-9068 -8056)",
    fill: "#85888A"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAngleRightSmallSecondary);
export default __webpack_public_path__ + "static/media/icon-angle-right-small-secondary.de7fa6b9.svg";
export { ForwardRef as ReactComponent };